import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { RouteSummaryReport } from './Pages';

export const RouteSummaryReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={RouteSummaryReport} />
    </Fragment>
)